import { isEqlFieldCommon } from '@modules/common/utils';
import { getDisplayNameFromField } from '@modules/common/utils/getDisplayNameFromField';
import { startCase } from 'lodash';
import { beautifyString } from 'v2/utils/strings';

interface GetFallbackDisplayNameForEqlFieldOptions {
  field: string;
  shouldShowSource?: boolean;
}

export const getFallbackDisplayNameForEqlField = ({
  field,
  shouldShowSource = false,
}: GetFallbackDisplayNameForEqlFieldOptions) => {
  if (!field.startsWith('metadata.')) {
    return getDisplayNameFromField(startCase(field)); // Non-metadata fields, this ideally should never run, added as a fallback
  }

  const [, source, metadataField] = field.split('.'); // format: 'metadata.<source>.<field>'

  if (!shouldShowSource) {
    return startCase(metadataField);
  }

  const sourceName = isEqlFieldCommon(field) ? 'Common' : source;
  return `${beautifyString(sourceName)} - ${startCase(metadataField)}`;
};
